// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cqxZn","top":"styles_top__2UTrd","left":"styles_left__1pC90","description":"styles_description__35T75"};